import { createContext } from "react";
import { TabletopCanvasInputMode } from "./TabletopCanvasInputMode";
import { TabletopCanvasInputDomain } from "./TabletopCanvasInputDomain";
import ITabletopShapeRenderer from "../objects/element/shape_renderer/ITabletopShapeRenderer";

export type TabletopCanvasInputState = {
    gridVisible: boolean;
    inputDomain: TabletopCanvasInputDomain;
    inputMode: TabletopCanvasInputMode;
    palette: {
        terrainShape?: ITabletopShapeRenderer | null;
    };
    snapToGrid: boolean;
};

export const DefaultCanvasInputState = {
    gridVisible: true,
    inputDomain: TabletopCanvasInputDomain.NAVIGATION,
    inputMode: TabletopCanvasInputMode.NAVIGATE_CANVAS,
    palette: {},
    snapToGrid: false,
};

type TabletopCanvasInputContextValue = {
    state: TabletopCanvasInputState;
    setState: (newState: TabletopCanvasInputState) => void;
};

const TabletopCanvasInputContext =
    createContext<TabletopCanvasInputContextValue>({
        state: DefaultCanvasInputState,
        setState: (_) => {},
    });

export { TabletopCanvasInputContext };
